import { RootState } from "../models";

export const selectIsEnded = (state: RootState) => {
    const isEnded = state.data.isLoaded ? state.video.isEnded : false;
    return isEnded;
};
